/**
 * Created by Ning Jiang on 3/31/2020.
 */

import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class WildNudgeIntroSlideShowPage extends SlideShowPage {

    constructor(textures:PIXI.Texture[], imageScales:number[], blendModes:boolean[]) {
        super(undefined, undefined);

        const length = textures.length;
        const w = Math.floor(700 / length);

        textures.forEach((t, i) => {
            const image = new PIXI.Sprite(textures[i]);
            image.anchor.set(0.5);
            image.position.x = -350 + (i + 0.5) * w;
            image.scale.set(imageScales[i]);
            if(blendModes[i]) {
                image.blendMode = PIXI.BLEND_MODES.ADD;
            }
            this.addChild(image);
        });
    }
}